var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasRole('ui', 'UI_ALL_COMPANIES') && _vm.selectedCompany)?_c('div',{staticClass:"table__alert"},[_vm._v("\n  "+_vm._s(_vm.$t((_vm.namespace + ".tableMessage")))+" "),_c('strong',[_vm._v(_vm._s(_vm.selectedCompany.name))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }